<template>
    <div>
        <FolderNavigator
            :showConfirmButton="true"
            :dossier="$store.state.currentDossier"
            :initial-path="subfolderPath"
            @path-selected="updateSubfolderPathFromNavigator"
            @cancel-change-save-path="folderNavigatorForAttachment = null"
            :attachment="folderNavigatorForAttachment"
            v-if="folderNavigatorForAttachment != null"
            />
        <div class="mt-4 no-gutters" v-show="folderNavigatorForAttachment == null">
            <div class="col-12 btn-group mb-4">
                <button class="btn btn-sm btn-outline-dark col-6" @click="$emit('hide-attachment-prompt')" :disabled="isSavingAttachments || isLinking">
                    <i class="fas fa-arrow-left"></i>
                    Annuler
                </button>
                <button class="btn btn-sm btn-outline-success col-6" @click="save" :disabled="isSavingAttachments || isLinking || $v.$anyError">
                    <i class="fas fa-spinner fa-spin" v-if="isSavingAttachments || isLinking"></i>
                    <span v-if="!isSavingAttachments && !isLinking">
                        <i class="fas fa-save"></i> Enregistrer
                    </span>
                </button>
            </div>
            <div class="form-group mb-5" v-if="mode == SaveMode.MAIL">
                <label style="font-size:14px">Nom du mail</label>
                <div class="input-group input-group-sm">
                    <input class="form-control"
                           type="text"
                           v-model="mailFilenameCopy"
                           @input="$v.mailFilenameCopy.$touch"
                           :class="{ 'is-invalid': $v.mailFilenameCopy.$anyError }"
                           :disabled="isSavingAttachments || isLinking"
                    />
                    <div class="input-group-append">
                        <span class="input-group-text" id="basic-addon2">.eml</span>
                    </div>
                    <div class="invalid-feedback" v-if="!$v.mailFilenameCopy.required">Champ obligatoire</div>
                    <div class="invalid-feedback" v-if="!$v.mailFilenameCopy.minLength">{{ $v.mailFilenameCopy.$params.minLength.min }} caractères requis.</div>
                    <div class="invalid-feedback" v-if="!$v.mailFilenameCopy.maxLength">{{ $v.mailFilenameCopy.$params.maxLength.max }} caractères max.</div>

                </div>
            </div>

            <div class="col-12" v-if="hasSupportedFiles">
                <div class="btn-group float-right">
                    <button
                        type="button"
                        class="btn btn-outline-info btn-sm btn-suggest-name"
                        @click="suggestNameForAll()"
                        :disabled="isSavingAttachments || isLinking || checkIsFetchingSuggestedNameForAll"
                        v-if="attachmentsCopy.length > 0 && hasMistralOcrCapability"
                        title="Suggérer un nom automatiquement"
                    >
                        <span class="fa-stack" v-if="!checkIsFetchingSuggestedNameForAll" style="font-size: 0.7em">
                            <i class="fas fa-font fa-stack-1x"></i>
                            <i class="fas fa-magic fa-stack-1x" style="transform: scale(1) translate(10px, -4px);"></i>
                        </span>
                        <i class="fas fa-spin fa-spinner" v-if="checkIsFetchingSuggestedNameForAll"></i>
                    </button>
                    <button
                        type="button"
                        class="btn btn-outline-secondary btn-sm"
                        @click="restoreNameForAll()"
                        :disabled="isSavingAttachments || isLinking || checkIsFetchingSuggestedNameForAll"
                        v-if="attachmentsCopy.length > 0 && checkHasSuggestedNameForAll"
                    >
                        <i class="fas fa-undo"></i>
                    </button>
                    <button
                        type="button"
                        class="btn btn-outline-info btn-sm btn-suggest-destination-folder"
                        @click="suggestDestinationFolderForAll()"
                        :disabled="isSavingAttachments || isLinking || checkIsFetchingSuggestedNameForAll || isSuggestingDestinationFolderForAll"
                        v-if="attachmentsCopy.length > 0 && hasMistralSuggestDestinationFolder"
                        title="Suggérer un répertoire automatiquement"
                    >
                        <span class="fa-stack" v-if="!isSuggestingDestinationFolderForAll" style="font-size: 0.7em">
                            <i class="fas fa-ellipsis-h fa-stack-1x"></i>
                            <i class="fas fa-magic fa-stack-1x" style="transform: scale(1) translate(10px, -4px);"></i>
                        </span>
                        <i class="fas fa-spin fa-spinner" v-if="isSuggestingDestinationFolderForAll"></i>
                    </button>
                </div>
            </div>
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>Pièces jointes</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="$v.attachmentsCopy.$error"><td class="invalid-feedback d-block">Un ou plusieurs champs sont invalides.</td></tr>
                    <tr v-for="(v, index) in $v.attachmentsCopy.$each.$iter" :key="index">
                        <td class="col-12">
                            <div class="input-group input-group-sm">
                                <input
                                    type="text"
                                    class="form-control"
                                    :value="stripExtension(v.name.$model)"
                                    @input="updateAttachmentName(v.$model, $event)"
                                    @blur="sanitizeAttachmentName(v.$model)"
                                    :class="{ 'is-invalid': $v.attachmentsCopy.$each[index].name.$error }"
                                    :disabled="isSavingAttachments || isLinking"
                                />
                                <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon2">{{ getExtension(v.name.$model) }}</span>
                                    <button
                                        class="btn btn-outline-info btn-sm btn-suggest-name"
                                        @click="suggestName(v.$model)"
                                        :disabled="isSavingAttachments || isLinking || checkIsFetchingSuggestedName(v.$model)"
                                        v-if="isSupportedFile(v.$model) && hasMistralOcrCapability"
                                    >
                                        <span class="fa-stack" v-if="!checkIsFetchingSuggestedName(v.$model)" style="font-size: 0.7em">
                                            <i class="fas fa-font fa-stack-1x"></i>
                                            <i class="fas fa-magic fa-stack-1x" style="transform: scale(1) translate(11px, -4px);"></i>
                                        </span>
                                        <i class="fas fa-spin fa-spinner" v-if="checkIsFetchingSuggestedName(v.$model)"></i>
                                    </button>
                                    <button
                                        class="btn btn-outline-secondary btn-sm"
                                        @click="restoreName(v.$model)"
                                        :disabled="isSavingAttachments || isLinking || checkIsFetchingSuggestedName(v.$model)"
                                        v-if="checkHasSuggestedName(v.$model)"
                                    >
                                        <i class="fas fa-undo"></i>
                                    </button>
                                    <button
                                        class="btn btn-outline-danger btn-sm"
                                        @click="removeAttachment(v.$model)"
                                        :disabled="(attachmentsCopy.length == 1 && mode == SaveMode.ATTACHMENTS) || isSavingAttachments || isLinking"
                                    >
                                        <i class="fas fa-times"></i>
                                    </button>
                                </div>
                                <div class="invalid-feedback" v-if="!v.name.required">Champ obligatoire</div>
                                <div class="invalid-feedback" v-if="!v.name.minLengthWithoutExt">{{ v.name.$params.minLengthWithoutExt.min }} caractères requis.</div>
                                <div class="invalid-feedback" v-if="!v.name.maxLengthWithoutExt">{{ v.name.$params.maxLengthWithoutExt.max }} caractères max.</div>
                            </div>
                            <div class="input-group input-group-sm input-group-change-save-path" v-if="hasPerAttachmentSavePathCapability">
                                <input
                                    type="text"
                                    class="form-control"
                                    :value="getAttachmentSavePath(v.$model)"
                                    :disabled="isSavingAttachments || isLinking"
                                    :title="getAttachmentSavePath(v.$model)"
                                    @click="changeSavePath(v.$model)"
                                    readonly
                                />
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary btn-sm btn-change-save-path" @click="changeSavePath(v.$model)" :disabled="isSavingAttachments || isLinking">
                                        <i class="fas fa-ellipsis-h"></i>
                                    </button>
                                    <button
                                        class="btn btn-outline-secondary btn-sm"
                                        @click="restoreSavePath(v.$model)"
                                        :disabled="isSavingAttachments || isLinking || checkIsFetchingSuggestedName(v.$model)"
                                        v-if="checkHasSuggestedSavePath(v.$model)"
                                    >
                                        <i class="fas fa-undo"></i>
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="attachmentsCopy.length == 0">
                        <td class="text-center">Aucune pièce jointe</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script lang="ts">
import FolderNavigator from './FolderNavigator.vue';
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { Attachment, SaveMode } from '../interfaces/interfaces'
import sanitize from 'sanitize-filename'
import Vuelidate from 'vuelidate'
import { helpers, required, minLength, maxLength } from 'vuelidate/lib/validators'
import LysiasApiMixin from '../mixins/LysiasApiMixin'
import { getResolvedPDFJS, renderPageAsImage } from 'unpdf'
import { responseFormatFromZodObject } from '@mistralai/mistralai/extra/structChat.js';
import { z } from 'zod';

const SchemaDocument = z.object({
  type_de_document: z.string(),
  courte_description: z.string(),
  nom_de_fichier_sans_extension: z.string(),
});

Vue.use(Vuelidate as any);

Component.registerHooks(['validations'])

@Component({ components: { FolderNavigator } })
export default class Attachments extends mixins(LysiasApiMixin)
{
    @Prop() readonly subfolderPath: string | undefined;
    @Prop() readonly attachments: Attachment[] | undefined;
    @Prop() readonly isSavingAttachments: boolean = false;
    @Prop() readonly isLinking: boolean = false;
    @Prop() readonly mailFilename?: string;
    @Prop() readonly mode?: string;
    private attachmentsCopy: Attachment[] = [];
    private attachmentsOriginalCopy: Attachment[] = [];
    private mailFilenameCopy?: string = "";
    private SaveMode = SaveMode;
    private isFetchingSuggestedName: {[key: string]: boolean} = {};
    private hasSuggestedName: {[key: string]: boolean} = {};
    private hasSuggestedSavePath: {[key: string]: boolean} = {};
    private folderNavigatorForAttachment?: Attachment|null = null;
    private isSuggestingDestinationFolderForAll = false;

    minLengthWithoutExt= (min: number) => {
        return helpers.withParams({ type: 'minLengthWithoutExt', min: min },
            (value: string) =>
            {
                return Attachments.stripExtension(value).length >= min;
            })
    };

    maxLengthWithoutExt= (max: number) => {
        return helpers.withParams({ type: 'maxLengthWithoutExt', max: max },
            (value: string) =>
            {
                return Attachments.stripExtension(value).length <= max;
            })
    };

    mounted()
    {
        console.clear();
        this.attachmentsCopy = this.attachments!;
        this.attachmentsOriginalCopy = JSON.parse(JSON.stringify(this.attachments!));
        this.mailFilenameCopy = this.mailFilename;
    }

    sanitizeAttachmentName(attachment: Attachment)
    {
        const index = this.attachmentsCopy.findIndex((a) => a.id === attachment.id);

        if (index === -1) {
            return;
        }

        const extension = this.getExtension(this.attachmentsCopy[index].name);
        const nameWithoutExtension = this.stripExtension(this.attachmentsCopy[index].name);
        const sanitizedName = sanitize(nameWithoutExtension);

        this.attachmentsCopy[index].name = sanitizedName
            ? sanitizedName + extension
            : extension;

        this.$emit('update-attachments', this.attachmentsCopy);
    }

    @Watch('mailFilenameCopy')
    onMailFilenameCopyChange()
    {
        const mailFilenameCopyWithExtension = sanitize(this.mailFilenameCopy! + '.eml');
        const mailFilenameCopyWithoutExtension = mailFilenameCopyWithExtension.substring(0, mailFilenameCopyWithExtension.lastIndexOf('.eml'));

        this.mailFilenameCopy = mailFilenameCopyWithoutExtension;
        this.$emit('update-mail-filename', this.mailFilenameCopy);
    }

    static stripExtension(filename: string)
    {
        const dotPosition = filename.lastIndexOf('.')
        if(dotPosition  == -1)
            return filename;

        return filename.substring(0, dotPosition);
    }

    stripExtension(filename: string)
    {
        return Attachments.stripExtension(filename);
    }

    getExtension(filename: string)
    {
        const dotPosition = filename.lastIndexOf('.')
        if(dotPosition  == -1)
            return '';

        return filename.substring(dotPosition);
    }

    save()
    {
        if(this.mode == SaveMode.ATTACHMENTS)
        {
            this.$emit('save-attachments')
        }
        else
        {
            this.$emit('save-mail')
        }
    }

    updateAttachmentName(attachment: Attachment, e: any)
    {
        const index = this.attachmentsCopy!.findIndex((a) => a.id == attachment.id);
        const extension = this.getExtension(attachment.name);
        this.attachmentsCopy[index].name = e.target.value + extension;
        this.$v.attachmentsCopy.$touch();
    }

    removeAttachment(attachment: Attachment)
    {
        const index = this.attachmentsCopy!.findIndex((a) => a.id == attachment.id);
        this.attachmentsCopy!.splice(index, 1);
    }

    restoreNameForAll()
    {
        for (let attachment of this.attachments!)
        {
            this.restoreName(attachment);
        }
    }

    restoreName(attachment: Attachment)
    {
        const foundOriginalAttachment = this.attachmentsOriginalCopy!.find((a) => a.id == attachment.id);
        const foundAttachmentIndex = this.attachmentsOriginalCopy!.findIndex((a) => a.id == attachment.id);
        this.attachmentsCopy[foundAttachmentIndex].name = foundOriginalAttachment!.name;
        this.$set(this.hasSuggestedName, this.attachmentsCopy[foundAttachmentIndex].id, false);
    }

    checkHasSuggestedName(attachment: Attachment): boolean
    {
        return attachment.id in this.hasSuggestedName && this.hasSuggestedName[attachment.id];
    }

    get checkHasSuggestedNameForAll(): boolean
    {
        for (let attachment of this.attachments!)
        {
            const hasSuggestedName = this.checkHasSuggestedName(attachment);
            if(hasSuggestedName)
            {
                return true;
            }
        }

        return false;
    }
    async suggestName(attachment: Attachment)
    {
        const foundAttachmentIndex = this.attachmentsCopy!.findIndex((a) => a.id == attachment.id);
        const foundAttachment = this.attachmentsCopy![foundAttachmentIndex];
        if(!this.isSupportedFile(foundAttachment!))
        {
            return;
        }
        const blob = this.base64toBlob(foundAttachment!.mimeContent!, foundAttachment!.contentType!);
        const suggestedFilename = await this.extractFirstPageTextAndSuggestFilename(attachment, blob);

        const extension = this.getExtension(attachment.name);
        const suggestedFilenameExtension = suggestedFilename ? this.getExtension(suggestedFilename) : '';
        let newName = suggestedFilename ? suggestedFilename.replace('.' + suggestedFilenameExtension, '') : '';

        if(newName)
        {
            this.attachmentsCopy[foundAttachmentIndex].name = newName + extension;
            this.$v.attachmentsCopy.$touch();
            this.$set(this.hasSuggestedName, foundAttachment.id, true);
        }
    }

    async extractFirstPageTextAndSuggestFilename(attachment: Attachment, blob: Blob)
    {
        try
        {
            this.$set(this.isFetchingSuggestedName, attachment.id, true);

            const extension = this.getExtension(attachment.name);
            let arrayBuffer = null;
            if(extension && extension == '.pdf')
            {
                const { getDocument } = await getResolvedPDFJS()
                const pdf = await getDocument(await this.blobToBuffer(blob)).promise;

                arrayBuffer = await renderPageAsImage(pdf, 1)
            }
            else if(extension)
            {
                arrayBuffer = await this.blobToBuffer(blob)
            }

            const ocrResponse = await this.processOcr(arrayBuffer!, attachment.name, {
                document_annotation_format: responseFormatFromZodObject(SchemaDocument),
            });

            let documentAnnotation = JSON.parse(ocrResponse.document_annotation!);

            this.$set(this.isFetchingSuggestedName, attachment.id, false);

            return documentAnnotation.nom_de_fichier_sans_extension;
        }
        catch (error)
        {
            this.$set(this.isFetchingSuggestedName, attachment.id, false);

            console.error("Error extracting text from PDF:", error);
            return null;
        }
    }

    validations()
    {
        const that = this;
        return {
            mailFilenameCopy:
            {
                required,
                minLength: minLength(3),
                maxLength: maxLength(200),
            },
            attachmentsCopy:
            {
                $each: {
                    name: {
                        required,
                        minLengthWithoutExt: that.minLengthWithoutExt(3),
                        maxLengthWithoutExt: that.maxLengthWithoutExt(200),
                    },
                }
            }
        };
    }

    checkIsFetchingSuggestedName(attachment: Attachment): boolean
    {
        return (attachment.id in this.isFetchingSuggestedName) && this.isFetchingSuggestedName[attachment.id];
    }

    get checkIsFetchingSuggestedNameForAll(): boolean
    {
        for (let attachment of this.attachments!)
        {
            const isFetchingSuggestedName = this.checkIsFetchingSuggestedName(attachment);
            if(isFetchingSuggestedName)
            {
                return true;
            }
        }

        return false;
    }

    suggestNameForAll()
    {
        for (let attachment of this.attachments!)
        {
            this.suggestName(attachment);
        }
    }

    isSupportedFile(attachment: Attachment)
    {
        const extension = this.getExtension(attachment.name);
        if(!extension)
        {
            return false;
        }

        return ['.pdf', '.png', '.jpg', '.jpeg', '.webp'].includes(extension);
    }

    hasSupportedFiles()
    {
        for (let attachment of this.attachments!)
        {
            if(this.isSupportedFile(attachment))
            {
                return true;
            }
        }

    }

    async blobToBuffer(blob: Blob): Promise<ArrayBuffer>
    {
        const arrayBuffer = await blob.arrayBuffer();
        return new Uint8Array(arrayBuffer);
    }

    changeSavePath(attachment: Attachment)
    {
        this.folderNavigatorForAttachment = attachment;
    }

    get hasMistralOcrCapability()
    {
        try
        {
            return this.$store.state.capabilities.includes('mistral_ocr') && (this.isAvailableForBetaTesting() || this.$store.state.hasAI);
        }
        catch(e)
        {
            console.error(e);
            return false;
        }
    }

    get hasMistralSuggestDestinationFolder()
    {
        try
        {
            return this.$store.state.capabilities.includes('mistral_suggest_destination_folder') && (this.isAvailableForBetaTesting() || this.$store.state.hasAI);
        }
        catch(e)
        {
            console.error(e);
            return false;
        }
    }

    isAvailableForBetaTesting()
    {
        return this.$store.state.currentCabinet && (this.$store.getters.normalizedCabinetUrl.includes('axio-avocat') || this.$store.getters.normalizedCabinetUrl.includes('localhost') || this.$store.getters.normalizedCabinetUrl.includes('bonavia') || this.$store.getters.normalizedCabinetUrl.includes('bklegal') || this.$store.getters.normalizedCabinetUrl.includes('support') || this.$store.getters.normalizedCabinetUrl.includes('copaver-avocat') || this.$store.getters.normalizedCabinetUrl.includes('legajuris') || this.$store.getters.normalizedCabinetUrl.includes('astenavocats') || this.$store.getters.normalizedCabinetUrl.includes('cesari-avocat') || this.$store.getters.normalizedCabinetUrl.includes('beaufigeau-avocat') || this.$store.getters.normalizedCabinetUrl.includes('dezalay-avocat') || this.$store.getters.normalizedCabinetUrl.includes('kbrunet-avocat'));
    }

    get hasPerAttachmentSavePathCapability()
    {
        try
        {
            return this.$store.state.capabilities.includes('per_attachment_save_path');
        }
        catch(e)
        {
            console.error(e);
            return false;
        }
    }

    updateSubfolderPathFromNavigator(path: string)
    {
        const attachmentIndex = this.attachmentsCopy!.findIndex((a) => a.id == this.folderNavigatorForAttachment!.id);
        this.attachmentsCopy![attachmentIndex].savePath = path;
        this.folderNavigatorForAttachment = null;
    }

    getAttachmentSavePath(attachment: Attachment)
    {
        if(!attachment.savePath)
        {
            const index = this.attachmentsCopy!.findIndex((a) => a.id == attachment.id);
            this.attachmentsCopy[index].savePath = this.subfolderPath;
            this.$v.attachmentsCopy.$touch();
        }

        return attachment.savePath;
    }

    updateAttachmentSavePath(attachment: Attachment, e: any)
    {
        const index = this.attachmentsCopy!.findIndex((a) => a.id == attachment.id);
        this.attachmentsCopy[index].savePath = e.target.value;
        this.$v.attachmentsCopy.$touch();
    }

    async suggestDestinationFolderForAll()
    {
        try
        {
            this.isSuggestingDestinationFolderForAll = true;
            const repertoiresHierarchy = this.$store.getters.getRepertoiresHierarchyHistoryFor(this.$store.state.currentDossier.id);
            const fileNames = this.attachmentsCopy.map(attachment => attachment.name);
            const suggestedNames = await this.suggestDestinationFolder(fileNames, repertoiresHierarchy)

            for (const [filename, savePath] of Object.entries(suggestedNames)) {
                if (typeof savePath !== 'string') continue

                const foundAttachmentIndex = this.attachmentsCopy!.findIndex((a) => a.name == filename);
                const foundAttachment = this.attachmentsCopy![foundAttachmentIndex];
                this.attachmentsCopy![foundAttachmentIndex].savePath = savePath;
                this.$set(this.hasSuggestedSavePath, foundAttachment.id, true);
            }
            this.isSuggestingDestinationFolderForAll = false;
        }
        catch(e)
        {
            this.isSuggestingDestinationFolderForAll = false;
            console.error(e);
        }
    }

    restoreSavePath(attachment: Attachment)
    {
        const foundOriginalAttachment = this.attachmentsOriginalCopy!.find((a) => a.id == attachment.id);
        const foundAttachmentIndex = this.attachmentsOriginalCopy!.findIndex((a) => a.id == attachment.id);
        this.attachmentsCopy[foundAttachmentIndex].savePath = foundOriginalAttachment!.savePath;
        this.$set(this.hasSuggestedSavePath, this.attachmentsCopy[foundAttachmentIndex].id, false);
    }

    checkHasSuggestedSavePath(attachment: Attachment): boolean
    {
        return attachment.id in this.hasSuggestedSavePath && this.hasSuggestedSavePath[attachment.id];
    }

}
</script>
<style scoped>
.btn-change-save-path
{
    font-size: 0.6em !important;
}

.input-group
{
    padding-top: .25rem;
    padding-bottom: .25rem;
}

.btn-suggest-name, .btn-suggest-destination-folder
{
    padding: .20rem !important;
    padding-left: .25rem !important;
    padding-right: .60rem !important;
}
</style>
